import React from "react";

function SubscriptionsSkeleton() {
  return (
    <div className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="h-28 animate-pulse rounded-[1.5rem] bg-slate-200 dark:bg-white/10"
          />
        ))}
      </div>

      <div className="h-32 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
      <div className="h-60 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
      <div className="h-[520px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
    </div>
  );
}

export default SubscriptionsSkeleton;